export default __webpack_public_path__ + "static/media/list-white.a1cc1447.svg";